import { EstimateRow } from "features/subscriptions/components/ManageSubscription/EstimateRow";
import { PRICING_PLANS } from "features/subscriptions/constants";
import useEstimateRenewal from "features/subscriptions/datahooks/useEstimateRenewal";
import {
  formatPrice,
  formatPricingPeriodInfo,
  parseEstimate,
} from "features/subscriptions/utils";

import { Tag } from "common/components/ui/Tag";
import type { PricingPeriodInfo, SubscriptionType } from "common/types";

export function CurrentSubscriptionEstimate({
  subscriptionType,
  quantity,
  subscriptionId,
  pricingPeriodInfo,
}: {
  subscriptionType: SubscriptionType;
  quantity: number;
  subscriptionId?: string;
  pricingPeriodInfo: PricingPeriodInfo;
}) {
  const { estimateRenewal, isLoadingEstimateRenewal } =
    useEstimateRenewal(subscriptionId);

  let value = "-";

  if (estimateRenewal) {
    const { amountDue } = parseEstimate(estimateRenewal);
    value = `${formatPrice(amountDue)} / ${formatPricingPeriodInfo(pricingPeriodInfo)}`;
  }

  return (
    <div className="relative mt-3.5">
      <Tag size="sm" variant="info" className="absolute -mt-3.5 ml-1.5">
        Current plan
      </Tag>
      {/* Current plan */}
      <div className="flex flex-col gap-y-2.5 rounded-2xl border border-black-200 bg-white py-2.5">
        <EstimateRow
          label={`No. of ${subscriptionType === "rental" ? "avatars" : "seats"}`}
          tooltipText={
            PRICING_PLANS[subscriptionType].tooltipText.currentQuantity
          }
          value={quantity}
          valueClassName="text-md-medium text-black-500"
          isLoading={false}
        />
        <EstimateRow
          label="Plan price"
          tooltipText={PRICING_PLANS[subscriptionType].tooltipText.currentPrice}
          value={value}
          valueClassName="text-md-medium text-black-500"
          isLoading={isLoadingEstimateRenewal}
        />
      </div>
    </div>
  );
}
